export function brl(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function dataBR(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('pt-BR')
}

const STATUS_LABEL: Record<string, string> = {
  triagem: 'Em triagem',
  proposta_enviada: 'Proposta enviada',
  contrato_pendente: 'Aguardando assinatura',
  docs_pendentes: 'Enviando documentos',
  em_producao: 'Em produção',
  aguardando_revisao: 'Em revisão pela equipe jurídica',
  protocolado: 'Protocolado',
  aguardando_liminar: 'Aguardando decisão da liminar',
  liminar_deferida: 'Liminar deferida',
  liminar_indeferida: 'Liminar indeferida',
  liminar_revogada: 'Liminar revogada',
  em_andamento: 'Em andamento',
  encerrado: 'Encerrado',
  improcedente: 'Improcedente',
  distratado: 'Distratado',
  arquivado: 'Arquivado',
}

export function statusLabel(status: string): string {
  return STATUS_LABEL[status] ?? status
}
